<template>
  <BaseNavBarCTA
    :title="fedexPreferred ? 'Time for your free pickup with FedEx' : 'More Perks With FedEx'"
    :description="fedexPreferred ? '' : 'Get free scheduled pickups & faster processing.'"
    :color="fedexPreferred ? 'orchid' : 'plum'">
    <template #button>
      <BaseLink
        v-if="fedexPreferred"
        class="mt-sm text-link"
        text="Schedule Home Pickup"
        type="link"
        variant="secondary"
        :to="{ name: 'account', query: { section: 'shipping-returns' } }"/>
      <BaseButton
        v-else
        class="mt-sm"
        text="Opt into FedEx"
        type="button"
        variant="secondary"
        @click="() => optIntoFedEx('modal')"/>
    </template>
  </BaseNavBarCTA>
</template>

<script setup>
import BaseNavBarCTA from '@/components/navigation/BaseNavBarCTA.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import BaseLink from '@shared/components/BaseLink.vue'
import { useFedExOptInStore } from '@/stores/fedExOptIn.js'
import { storeToRefs } from 'pinia'

const { fedexPreferred } = storeToRefs(useFedExOptInStore())
const { optIntoFedEx } = useFedExOptInStore()
</script>
